/* componentId
 *
 * `generateId` generates a unique (per page load) ID using a given prefix.
 *  It's meant to be used when a unique HTML element ID is required per component instance.
 *  For example for SVG gradients or in `aria-describedby` attributes.
 */
let idCounter = 0;

export function generateId(prefix: string): string {
  idCounter += 1;
  return `${prefix}${idCounter}`;
}
